import { Module, Action, getModule } from 'vuex-module-decorators';
import EntityBaseModule from '@/store/entity';
import store from '@/store';
import { PartnerModel, PartnerRequest } from '@/types/models/partners';
import EntityModel from './entityModel';
import { Partners } from '@/models/partners';
import { getById, addNewEntity, updateEntity, removeEntity } from '@/api/crud';

export const MODULE_NAME = Partners.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PartnerEntityModule extends EntityBaseModule {
    model: PartnerModel;

    constructor(module: PartnerEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(Partners.apiPrefix, id);

            return result.partner;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async createNew(data: PartnerRequest) {
        return addNewEntity(Partners.apiPrefix, data);
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: PartnerRequest }) {
        return updateEntity(Partners.apiPrefix, params.id, params.data);
    }

    @Action({ rawError: true })
    async remove(id: string) {
        return removeEntity(Partners.apiPrefix, id);
    }

    @Action({ rawError: true })
    async getIsActive(id: string) {
        const result = await this.getById(id);
        return result.isActive;
    }
}

export default getModule(PartnerEntityModule);
